import React from "react";
import { Link } from "react-router-dom";
import { useUserData } from "../utils/UserData";
import BackToTop from "./BackToTop";
import CarbonBadge from "./CarbonBadge";

export default function Footer() {
  const data = useUserData();

  return (
    <footer className="bg-slate-900 text-slate-300 py-10 px-4 font-sans mt-12">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:justify-between items-center gap-6 text-center md:text-left">
        {/* Social Icons + Quick Links */}
        <div className="space-y-4">
          <ul className="flex justify-center md:justify-start items-center gap-6 text-purple-400 text-xl">
            <li>
              <Link to={`mailto:${data.socialMedia.email}`} rel="noopener noreferrer">
                <i className="fa-solid fa-envelope hover:text-purple-300 transition-colors" />
              </Link>
            </li>
            <li>
              <Link to={data.socialMedia.linkedin} rel="noopener noreferrer">
                <i className="fa-brands fa-linkedin-in hover:text-purple-300 transition-colors" />
              </Link>
            </li>
            <li>
              <Link to={data.socialMedia.github} rel="noopener noreferrer">
                <i className="fa-brands fa-github hover:text-purple-300 transition-colors" />
              </Link>
            </li>
            <li>
              <Link to={data.socialMedia.devTo} rel="noopener noreferrer">
                <i className="fa-brands fa-dev hover:text-purple-300 transition-colors" />
              </Link>
            </li>
            <li>
                <Link to="https://www.npmjs.com/~sarahcssiqueira" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-npm text-xl text-purple-600"></i>
            </Link>
            </li>
          </ul>

          <ul className="flex justify-center md:justify-start gap-4 text-sm text-slate-400">
            <li><Link to="/about" className="hover:text-purple-300">About</Link></li>
            <li><Link to="/contact" className="hover:text-purple-300">Contact</Link></li>
            <li><Link to="/code-samples" className="hover:text-purple-300">Code</Link></li>
          </ul>
        </div>

        {/* Copyright */}
        <div className="text-sm text-slate-500">
          <p>© 2015 – {new Date().getFullYear()} Sarah Siqueira.</p>
          <p>Built with React, Tailwind CSS, and love 💜</p>
          <div className="mt-2 flex justify-center md:justify-start">
            <CarbonBadge />
          </div>
        </div>
      </div>

      {/* Scroll to Top */}
      <div className="mt-6 text-center">
        <BackToTop />
      </div>
    </footer>
  );
}
